const transform = <C>(value: C): string => {
  return JSON.stringify(value)
}

const transformBack = <C>(val: string): C => {
  try {
    const parserItem: C = JSON.parse(val)
    return parserItem
  } catch (e) {
    console.assert(e)
  }
}
const CACHE_NAMESPACE = '@ConexaPaciente'

export const hasCache = (key: string): boolean =>
  !!sessionStorage.getItem(`${CACHE_NAMESPACE}:${key}`)

export const getCache = <C>(key: string): C =>
  transformBack<C>(sessionStorage.getItem(`${CACHE_NAMESPACE}:${key}`))

export const setCache = <C>(key: string, value: C): void => {
  sessionStorage.setItem(`${CACHE_NAMESPACE}:${key}`, transform<C>(value))
}

export const removeCache = (key: string): void => {
  sessionStorage.removeItem(`${CACHE_NAMESPACE}:${key}`)
}

export const resetCache = (): void => {
  sessionStorage.clear()
}
